import { render, staticRenderFns } from "./Joint.vue?vue&type=template&id=1a7b4db6&scoped=true&"
import script from "./Joint.vue?vue&type=script&lang=js&"
export * from "./Joint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b4db6",
  null
  
)

export default component.exports